import { Params, useRequest } from "~/api/Request"
import API_V2 from "../api/api-v2"
import {
  ContractDocument,
  ContractDocumentDetail,
  DisableReason,
  DocumentWorkFlowDisplayResponse,
} from "../model/ContractDocument"
import { FileObject, UploadedBucketFile } from "~/model/Workflow"
import API from "~/api/api"

export function useContractDocument() {
  const { Request } = useRequest()
  return {
    getContractDocumentsByContractId: async (contractId: number | string) => {
      const url = API_V2.CONTRACT_DOCUMENT.replace("{contractId}", String(contractId))
      const response = await Request.get<ContractDocument[]>(url)
      return response.data
    },
    getContractDocumentDetailById: async (contractDocumentId: number | string) => {
      const url = API_V2.CONTRACT_DOCUMENT_DETAIL.replace(
        "{contractDocumentId}",
        String(contractDocumentId)
      )
      //FIXME: type may not correct
      const response = await Request.get<any>(url)
      return {
        ...response.data,
        // Only god knows why ¯\_(ツ)_/¯
        notRequireUpload: response.data.isRequireUpload,
      } as ContractDocumentDetail
    },

    getContractDocumentToDisplay: async (contractDocumentId: number | string) => {
      const url = API_V2.CONTRACT_DOCUMENT_T0_DISPLAY.replace(
        "{contractDocumentId}",
        String(contractDocumentId)
      )
      const response = await Request.get<DocumentWorkFlowDisplayResponse>(url)
      return response.data
    },

    createContractDocument: async (payload: {
      contractId: number
      workflowId: number
      file?: FileObject | UploadedBucketFile
    }) => {
      const url = API_V2.CONTRACT_DOCUMENT_CREATE
      //FIXME: type may not correct
      const response = await Request.post<ContractDocumentDetail>(url, payload)
      return response.data
    },
    batchDeleteContractDocument: async (payload: {
      contractId: number
      contractDocumentIds: number[]
    }) => {
      const url = API_V2.CONTRACT_DOCUMENT_BATCH_DELETE
      const response = await Request.post(url, payload)
      return response.data
    },
    
    disableContractDocument: async (contractDocumentId: number, payload: { disableReason: DisableReason, disableNote: string }) => {
      const url = API.DISABLE_CONTRACT_DOCUMENT.replace(
        "{contractDocumentId}",
        String(contractDocumentId)
      )
      const response = await Request.post(url, payload)
      return response.data
    }
  }
}
